var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-default relative bg-gray-100",class:[_vm.layoutClass]},[_c('DefaultHeader'),_c('div',{staticClass:"bg-primary"},[_c('TabHeader')],1),_c('div',{staticClass:"content"},[_c('router-view')],1),_c('DefaultFooter'),_c('el-backtop',[_c('div',[_c('el-icon',{staticClass:"el-icon-caret-top"})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }